<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">GOSSIP</span>
          <small class="d-block">DIRECTORY</small>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link " routerLink="/" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/platforms" (click)="isNavOpen = false">Platforms</a></li>
          <li class="nav-item">
            <a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Your Card</a>
          </li>
          <li class="nav-item"><a class="nav-link" routerLink="/hardship" (click)="isNavOpen = false">Harships Incentives</a></li>
        </ul>
      </div>
      <div class="d-none d-md-flex align-items-center gap-2">
        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">LOGIN</a>
        <a href="/?authTab=register#register" class="btn btn-pink">
          REGISTER NOW
        </a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ HERO ============ -->
<section class="ht-hero">
  <div class="container text-center">
    <h1 class="ht-hero-title">HOW TO <span class="text-pink">GET STARTED</span></h1>
    <p class="ht-hero-subtitle">CONTENT CREATORS: START HERE</p>
    <p class="ht-hero-tags">
      REGISTER <span>•</span> ACTIVATE YOUR REFERRAL CODE <span>•</span> SHARE YOUR CARD <span>•</span> GROW
    </p>
  </div>
</section>

<!-- ============ MAIN TWO-COLUMN LAYOUT ============ -->
<section class="ht-body">
  <div class="container">
    <div class="ht-grid">

      <!-- LEFT: numbered steps -->
      <div class="ht-steps-col">
        <div class="ht-step-card" *ngFor="let step of steps">
          <img class="ht-step-badge" [src]="step.badge" [alt]="step.title">

          <div class="ht-step-content">
            <h3>{{ step.title }}</h3>
            <p *ngFor="let line of step.body">{{ line }}</p>
            <span class="ht-step-highlight" *ngIf="step.highlight">{{ step.highlight }}</span>

            <div class="ht-step-social" *ngIf="step.showSocial">
              <img src="assets/images/howto/social-icons.png" alt="Share to YouTube, TikTok, Instagram, Facebook, X, Podcast, Email">
            </div>
          </div>

          <div class="ht-step-media" [class.two-up]="step.images.length > 1">
            <img *ngFor="let img of step.images" [src]="img" [alt]="step.title">
          </div>
        </div>
      </div>

      <!-- RIGHT: referral credit explainer -->
      <div class="ht-info-col">

        <div class="ht-credit-panel">
          <h3 class="ht-panel-title">IMPORTANT: HOW YOU RECEIVE REFERRAL CREDIT</h3>
          <p class="ht-panel-text">
            Your followers and businesses must register
            <span class="text-pink">through your UMYO digital card.</span>
            They must:
          </p>
          <p class="ht-panel-flow-text">
            OPEN YOUR CARD → PRESS "SIGN UP" → COMPLETE REGISTRATION
          </p>
          <p class="ht-panel-text-sm">
            When they press Sign Up directly from your card, your unique referral
            code is automatically connected to their registration so the system
            can properly track and credit the referral to you.
          </p>

          <div class="ht-credit-steps">
            <div class="ht-credit-step" *ngFor="let cs of creditSteps">
              <span class="ht-credit-num">{{ cs.num }}</span>
              <div class="ht-credit-icon">
                <img [src]="cs.icon" [alt]="cs.title">
              </div>
              <span class="ht-credit-title">{{ cs.title }}</span>
            </div>
          </div>
        </div>

        <div class="ht-warning-panel">
          <img class="ht-warning-graphic" src="assets/images/howto/manual-referral.png" alt="Referrals cannot be manually added after registration">
          <p class="ht-warning-text">
            If someone registers without using Sign Up from your card, UMYO
            cannot manually go back and assign that registration to your
            referral account.
          </p>
          <img class="ht-warning-cta-graphic" src="assets/images/howto/share.png" alt="Share your card. They press sign up. The system tracks it.">
        </div>

        <div class="ht-community-panel">
          <h3>THE COMMUNITY WINS TOO</h3>
          <p>
            As the UMYO Gossip ecosystem grows,
            <span class="text-pink">up to 20%</span> can be allocated toward
            community hardship incentives and assistance programs. That can
            help participating members with needs such as:
          </p>

          <div class="ht-hardship-grid">
            <div class="ht-hardship-item" *ngFor="let item of hardshipItems">
              <img [src]="item.icon" [alt]="item.label">
            </div>
          </div>

          <p class="ht-community-footer">
            THE MORE WE GROW,<br><span class="text-pink">THE MORE WE CAN HELP.</span>
          </p>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- ============ BOTTOM STATS ROW ============ -->
<section class="ht-stats-section">
  <div class="container">
    <div class="ht-stats-grid">

      <div class="ht-stats-card">
        <h4 class="ht-stats-title">WHAT COULD 5,000 PARTICIPATING MEMBERS LOOK LIKE?</h4>
        <span class="ht-stats-note">SIMPLE EXAMPLE</span>
        <div class="ht-stats-row">
          <span>4,000 Residents x $2.54</span>
          <span class="ht-stats-value">= $10,160 / Month</span>
        </div>
        <div class="ht-stats-row">
          <span>1,000 Businesses x $49.99</span>
          <span class="ht-stats-value">= $49,990 / Month</span>
        </div>
        <div class="ht-stats-total">
          <span>5,000 TOTAL PARTICIPATING MEMBERS</span>
          <h2>$60,150</h2>
          <span>TOTAL MONTHLY ECOSYSTEM REVENUE</span>
        </div>
      </div>

      <div class="ht-stats-card ht-stats-earnings">
        <span class="ht-stats-note">15% CREATOR EARNINGS EXAMPLE</span>
        <h2>$9,022.50</h2>
        <span class="ht-stats-label">ILLUSTRATIVE MONTHLY CREATOR EARNINGS</span>
        <p>
          Actual earnings depend on qualifying paid memberships and businesses
          properly registered through your referral card, continued
          participation, program terms, and applicable policies.
        </p>
        <p class="text-pink ht-stats-disclaimer">EARNINGS ARE NOT GUARANTEED.</p>
      </div>

      <div class="ht-stats-card ht-stats-summary">
        <div class="ht-summary-row" *ngFor="let item of summaryList">
          <span class="ht-summary-symbol">{{ item.symbol }}</span>
          <span>{{ item.text }}</span>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">GOSSIP</span></div>
        </div>
        <small class="d-block pkg-footer-muted">YOUR VOICE. YOUR COMMUNITY.<br>POWERED BY UMYO.</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">QUICK LINKS</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/platforms">Platforms</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">RESOURCES</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="/how-to">How To</a></li>
          <li><a routerLink="/hardship">Hardship Incentives</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">LET'S CONNECT</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>© 2026 UMYO Gossip Directory. All Rights Reserved.</small>
    </div>
  </div>
</footer>